"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _get2 = _interopRequireDefault(require("lodash/get"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var Cccisd = window.cccisd;
var _default = exports["default"] = function _default(column, returnColumn) {
  if (column === null || _typeof(column) !== 'object') {
    return returnColumn;
  }
  if ('renderAs' in column && 'settings' in column.renderAs && 'appdefsEnum' in column.renderAs.settings && 'filterSettings' in column && column.filterSettings.type === 'selectbox') {
    var settings = column.renderAs.settings;
    var enumOptions = Cccisd;
    if (enumOptions) {
      enumOptions = settings.basePath ? enumOptions[settings.basePath] : enumOptions.appDefs;
    }
    if (!enumOptions) {
      return returnColumn;
    }
    // Chain into appDefs to locate enum
    settings.appdefsEnum.forEach(function (chain) {
      if (chain.path) {
        enumOptions = (0, _get2["default"])(enumOptions, chain.path);
      }
      if (chain.arrayKey && chain.arrayValueAtKey && enumOptions) {
        enumOptions = enumOptions.find(function (e) {
          return e[chain.arrayKey] === chain.arrayValueAtKey;
        });
      }
    });
    if (!Array.isArray(enumOptions) && _typeof(enumOptions) !== 'object') {
      return returnColumn;
    }
    var labelKey = settings.labelKey ? settings.labelKey : 'name';
    var valueKey = settings.valueKey ? settings.valueKey : 'value';
    var options = [];
    if (settings.objectKeyValues) {
      Object.keys(enumOptions).forEach(function (optionValue) {
        options.push({
          label: enumOptions[optionValue][labelKey],
          value: optionValue
        });
      });
    } else {
      options = enumOptions.map(function (option) {
        return {
          label: option[labelKey],
          value: option[valueKey]
        };
      });
    }
    returnColumn.filterSettings = column.filterSettings;
    returnColumn.filterSettings.options = options;
    return returnColumn;
  }
  return returnColumn;
};